export default (icons, showSupportEmail, showSupportWebUrl) => {
    return [
        {
            name: 'id',
            label: 'Id'
        },
        {
            name: 'title',
            label: 'Title'
        },
        {
            name: 'billingAccountId',
            label: 'Billing account Id'
        },
        {
            name: 'csgAccountId',
            label: 'CSG account Id'
        },
        {
            name: 'pmsStatus',
            label: 'PMS Status',
            component: {
                type: 'pms-status',
                props: {
                    Icon: icons.device,
                    color: 'accent',
                    class: 'px-1'
                }
            }
        },
        {
            name: 'addr1',
            label: 'Address 1'
        },
        {
            name: 'addr2',
            label: 'Address 2'
        },
        {
            name: 'city',
            label: 'City'
        },
        {
            name: 'stateName',
            label: 'State'
        },
        {
            name: 'zip',
            label: 'Zip'
        },
        {
            name: 'phone',
            label: 'Phone'
        },
        {
            name: 'ipv4AddressRange',
            label: 'IP4 Range'
        },
        {
            name: 'ipv6AddressRange',
            label: 'IP6 Range'
        },
        {
            name: 'rebootTime',
            label: 'Reboot time'
        },
        {
            name: 'defaultPublicChannelMapName',
            label: 'Default public channel lineup'
        },
        {
            name: 'defaultPrivateChannelMapName',
            label: 'Default private channel lineup'
        },
        {
            name: 'supportNumber',
            label: 'Support number',
            component: {
                type: 'action-link-button',
                props: {
                    linkType: 'tel',
                    prependIcon: icons.phone,
                    color: 'accent',
                    class: 'px-1'
                }
            }
        },
        {
            name: 'supportEmail',
            label: 'Support email',
            hideLabel: !showSupportEmail,
            component: {
                type: 'action-link-button',
                props: {
                    linkType: 'mailto',
                    prependIcon: icons.email,
                    color: 'accent',
                    class: 'px-1'
                }
            }
        },
        {
            name: 'supportWebUrl',
            label: 'Support URL',
            hideLabel: !showSupportWebUrl,
            component: {
                type: 'action-link-button',
                props: {
                    prependIcon: icons.launch,
                    linkTarget: '_blank',
                    color: 'accent',
                    class: 'px-1'
                }
            }
        }
    ];
};
